import React from "react";
import "./AboutSection.css";
import FeaturesSection from "./FeaturesSection";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";
import { Link } from "react-router-dom";

const services = [
  "Office Stationery",
  "Custom Printed Stationery",
  "Printers & Consumables",
  "Office Furniture",
  "Boardroom Equipment",
  "Acrylic Brochures & Stands",
  "Lanyards & Badges",
];

const values = [
  "Free Delivery Across UAE",
  "Quick Order Processing",
  "Seasonal Promotions",
  "Guaranteed Products",
  "Professional Support",
];

const AboutSection = () => {
  return (
    <>
      <Seo {...PAGE_SEO.about} />
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-content">
          <span className="about-badge">About SG Office</span>

          <h1>Your Trusted Partner for Office & Educational Supplies</h1>

          <p>
            Founded in 2010, SG Office Supplies LLC has grown into a trusted
            supplier of office stationery, educational products, printing
            solutions, and workspace essentials across the UAE.
          </p>

          <p>
            We focus on delivering quality products, competitive pricing, and
            dependable customer service for schools, offices, businesses, and
            institutions.
          </p>

          <Link className="about-btn" to={'/products'}>Shop Now</Link>
        </div>

        <div className="about-cards">
          <div className="mission-card">
            <h3>Our Mission</h3>
            <p>
              To become the preferred office products supplier by consistently
              delivering quality, value, and customer satisfaction.
            </p>
          </div>

          <div className="mission-card dark-card">
            <h3>Our Vision</h3>
            <p>
              To provide businesses, schools, and organizations with reliable
              products and smart solutions that support productivity and growth.
            </p>
          </div>
        </div>
      </div>
      <FeaturesSection/>

      <div className="services-box">
        <div className="section-title">
          <h3>Products & Services</h3>
          <p>Complete solutions for offices, schools, and business needs.</p>
        </div>

        <div className="services-grid">
          {services.map((item, index) => (
            <div className="service-item" key={index}>
              {item}
            </div>
          ))}
        </div>
      </div>

      <div className="value-box">
        {values.map((item, index) => (
          <div className="value-item" key={index}>
            ✓ {item}
          </div>
        ))}
      </div>
    </section>
    </>
  );
};

export default AboutSection;